import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStack24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconImageStack24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18 5.5H8A1.5 1.5 0 0 0 6.5 7H15a3 3 0 0 1 3 3v5.5a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 18 5.5M18 17a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3 3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M5 8.5h10a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.022 1.422l-.053-.04-8-5.5-.467-.32-.436.36-3.022 2.5V10A1.5 1.5 0 0 1 5 8.5m-1.462 8.837A1.5 1.5 0 0 0 5 18.5h7.949l-5.907-4.061zM13 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStack24);
